import { render } from "./RedirectTo.vue?vue&type=template&id=6c9eb421"
import script from "./RedirectTo.vue?vue&type=script&lang=js"
export * from "./RedirectTo.vue?vue&type=script&lang=js"
script.render = render

export default script